import React, { useEffect, createElement } from 'react';
import { HeroSection } from '../components/HeroSection';
import { OpeningHook } from '../components/OpeningHook';
import { ProblemSection } from '../components/ProblemSection';
import { MechanismSection } from '../components/MechanismSection';
import { OfferSection } from '../components/OfferSection';
import { AudienceSection } from '../components/AudienceSection';
import { HowItWorks } from '../components/HowItWorks';
import { ProofSection } from '../components/ProofSection';
import { FAQSection } from '../components/FAQSection';
import { PriceBlock } from '../components/PriceBlock';
import { SectionDivider } from '../components/SectionDivider';
declare global {
  interface Window {
    fbq: (...args: any[]) => void;
    _fbq: any;
  }
}
export function LandingPage() {
  useEffect(() => {
    // Set page title
    document.title = "The Voice They Couldn't Silence";
    // Meta Pixel initialization
    if (!window.fbq) {
      const n: any = window.fbq = function () {
        n.callMethod ? n.callMethod.apply(n, arguments) : n.queue.push(arguments);
      };
      if (!window._fbq) window._fbq = n;
      n.push = n;
      n.loaded = true;
      n.version = '2.0';
      n.queue = [];
      const t = document.createElement('script');
      t.async = true;
      t.src = 'https://connect.facebook.net/en_US/fbevents.js';
      document.head.appendChild(t);
    }
    window.fbq('init', '1584241515962496');
    window.fbq('track', 'PageView');
  }, []);
  return <div className="min-h-screen bg-navy-950 text-slate-300 font-sans selection:bg-patriot-red selection:text-white relative" data-id="element-364">
      {/* Persistent Background Image */}
      <div className="fixed inset-0 z-0 pointer-events-none" style={{
      backgroundImage: 'url(https://cdn.magicpatterns.com/uploads/rNw4WGmdracZPdbTKBC8ZC/backgroud.png)',
      backgroundSize: 'cover',
      backgroundPosition: 'center top',
      backgroundRepeat: 'no-repeat',
      backgroundAttachment: 'fixed',
      opacity: 0.12,
      mixBlendMode: 'luminosity'
    }} aria-hidden="true" data-id="element-365" />
      {/* Dark overlay to ensure readability */}
      <div className="fixed inset-0 z-0 pointer-events-none bg-navy-950/70" aria-hidden="true" data-id="element-366" />

      {/* Meta Pixel noscript fallback */}
      <noscript data-id="element-367">
        <img height="1" width="1" style={{
        display: 'none'
      }} src="https://www.facebook.com/tr?id=1584241515962496&ev=PageView&noscript=1" alt="" data-id="element-368" />
      </noscript>

      {/* Sticky Top Banner */}
      <div className="sticky top-0 z-50 w-full bg-red-gradient text-white font-bold text-center py-3 px-4 md:text-base shadow-[0_4px_20px_rgba(178,34,52,0.4)] border-b border-patriot-red/40 text-[12px]" data-id="element-369">
        <span className="animate-pulse mr-2" data-id="element-370">🔥</span>
        LIMITED TIME: 82% OFF — Only $17 (Regular $97)
      </div>

      <main className="relative z-10" data-id="element-371">
        <HeroSection data-id="element-372" />
        <OpeningHook data-id="element-373" />
        <SectionDivider data-id="element-374" />
        <ProblemSection data-id="element-375" />
        <MechanismSection data-id="element-376" />
        <OfferSection data-id="element-377" />
        <SectionDivider data-id="element-378" />
        <AudienceSection data-id="element-379" />
        <HowItWorks data-id="element-380" />
        <ProofSection data-id="element-381" />
        <FAQSection data-id="element-382" />
        <PriceBlock data-id="element-383" />
      </main>

      <footer className="relative z-10 py-8 text-center border-t border-navy-800 bg-navy-950/90" data-id="element-384">
        <div className="max-w-4xl mx-auto px-4" data-id="element-385">
          <p className="text-slate-500 text-sm font-mono mb-2 uppercase tracking-widest" data-id="element-386">
            © {new Date().getFullYear()} The Legacy of the Unbreakable Voice.
            All rights reserved.
          </p>
          <p className="text-slate-600 text-xs max-w-2xl mx-auto" data-id="element-387">
            This site is not a part of the Facebook website or Facebook Inc.
            Additionally, This site is NOT endorsed by Facebook in any way.
            FACEBOOK is a trademark of FACEBOOK, Inc.
          </p>
        </div>
      </footer>
    </div>;
}